import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import SortBy from "../components/SortBy";
import DownloadBtn from "../components/DownloadBtn";
import IndividualApprovedTable from "../components/IndividualApprovedTable";
import IndividualDeclinedTable from "../components/IndividualDeclinedTable";
// import StudenInProgressTable from '../components/StudenInProgressTable';
import { useDispatch, useSelector } from "react-redux";
import {
  setUpdateIndividualsStatus,
  setUpdateIndividualsPagination,
  setUpdateIndividualsPageSize,
} from "../redux/slices/individualApplicationApprovalSlice";
import { fetchIndividualApplicationApproval } from "../redux/slices/individualApplicationApprovalSlice";
import IndividualPendingTable from "../components/IndividualPendingTable";

const Individual = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const errorsArray = Array.isArray(error) ? error : [error];

  const IndividualApplication = useSelector(
    (state) => state?.individualApplicationApproval
  );

  const getAllIndividualApplication = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await dispatch(fetchIndividualApplicationApproval());
      if (response?.payload?.name === "AxiosError") {
        setLoading(false);
        setError(
          response?.payload?.response?.data?.errors?.map((errors) => errors) ||
            response?.payload?.response?.data?.error?.description ||
            "Failed to get Individual Applications"
        );
      }
      setLoading(false);
    } catch (error) {
      setError(
        error?.payload?.message ||
          "Failed to get Individual Applications, please check your network"
      );
    }
  }, [dispatch]);

  useEffect(() => {
    getAllIndividualApplication();
  }, [getAllIndividualApplication, IndividualApplication?.IndividualsParams]);

  const handleStatusChange = (status) => {
    dispatch(setUpdateIndividualsStatus(status));
    getAllIndividualApplication();
  };

  const handlePagination = (page) => {
    dispatch(setUpdateIndividualsPagination(page));
  };

  const handlePageSize = (size) => {
    dispatch(setUpdateIndividualsPageSize(size));
  };

  const IndividualAppData = {
    handlePagination,
    handlePageSize,
    itemsPerPage: IndividualApplication?.Individuals?.currentPageRecord,
    totalRecord: IndividualApplication?.Individuals?.totalRecord,
    pageNumber: IndividualApplication?.IndividualsParams?.page,
    nextPage: IndividualApplication?.Individuals?.nextPage,
    previousPage: IndividualApplication?.Individuals?.previousPage,
    pageSize: IndividualApplication?.IndividualsParams?.pageSize,
  };

  return (
    <Box pt={2} pb={5} minH={"100vh"} px={3}>
      <Flex
        bg={"#FFFFFF"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={"20px"}
        py={2}
        px={3}
        mb={5}
      >
        <Text fontSize={"18px"} fontWeight={"700"} color={"brand.primary"}>
          Individual Application
        </Text>
        <Flex
          flexDirection={["column", "column", "row"]}
          alignItems={"center"}
          gap={[3, null, null]}
        >
          <SortBy />
          <DownloadBtn />
        </Flex>
      </Flex>
      <Tabs variant="unstyled">
        <TabList
          gap={"20px"}
          flexDirection={["column", "row", "row"]}
          pb={4}
          justifyContent={["center", "flex-start", "flex-start"]}
          alignItems={"center"}
        >
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Pending")}
          >
            Pending
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Approved")}
          >
            Approved
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Declined")}
          >
            Declined
          </Tab>
          {/* <Tab _selected={{ color: '#FFFFFF', bg: '#D11A2A' }}
         bg={'#E9E9E9'} w={['100%', '18%', '18%', '18%']}  borderRadius={'4px'} lineHeight={'-0.25px'} color={'#54595F'}
        >In-progress</Tab> */}
        </TabList>

        <TabPanels bg={"#FFFFFF"}>
          <TabPanel>
            <IndividualPendingTable
              IndividualApplication={IndividualApplication}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...IndividualAppData}
            />
          </TabPanel>
          <TabPanel>
            <IndividualApprovedTable
              IndividualApplication={IndividualApplication}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...IndividualAppData}
            />
          </TabPanel>
          <TabPanel>
            <IndividualDeclinedTable
              IndividualApplication={IndividualApplication}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...IndividualAppData}
            />
          </TabPanel>
          {/* <TabPanel>
          <StudenInProgressTable />
        </TabPanel> */}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Individual;
